import React, { useState, useEffect } from "react";
import styles from "./Navbar.module.css";
import { Menu, Close, Download, Moon, Sun } from "../common/Icons";
import { Github, Linkedin } from "../common/BrandIcons";

const NAV_ITEMS = [
  { index: "01", label: "About", href: "#about" },
  { index: "02", label: "Experience", href: "#experience" },
  { index: "03", label: "Projects", href: "#projects" },
  { index: "04", label: "Open source", href: "#drawon" },
  { index: "05", label: "Contact", href: "#contact" },
];

const GITHUB_URL = "https://github.com/PratikTomar";
const LINKEDIN_URL = "https://www.linkedin.com/in/pratik-singh-tomar/";
const RESUME_URL = "../Pratik_Singh.pdf";

const Navbar = ({ theme, onToggleTheme }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isDark = theme === "dark";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 12);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && menuOpen) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [menuOpen]);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.bar}>
        <a className={styles.brand} href="#top" aria-label="Pratik Singh Tomar, back to top">
          <span className={styles.brandName}>Pratik Singh Tomar</span>
          <span className={styles.brandRole}>Senior full-stack engineer</span>
        </a>

        <nav className={styles.nav} aria-label="Sections">
          <ul className={styles.navList}>
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a href={item.href} className={styles.navLink}>
                  <span className={styles.navIndex}>{item.index}</span>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.actions}>
          <a
            className={styles.textLink}
            href={GITHUB_URL}
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            className={styles.textLink}
            href={LINKEDIN_URL}
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          <button
            type="button"
            className={styles.themeToggle}
            onClick={onToggleTheme}
            aria-pressed={isDark}
            aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
            title={isDark ? "Switch to light theme" : "Switch to dark theme"}
          >
            {isDark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <a
            className={styles.cvBtn}
            href={RESUME_URL}
            download="Pratik_Singh.pdf"
          >
            <Download size={14} />
            <span>CV</span>
          </a>

          <button
            className={styles.menuBtn}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="mobile-nav-menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <Close size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          className={styles.backdrop}
          onClick={() => setMenuOpen(false)}
          aria-hidden="true"
        />
      )}

      <div
        id="mobile-nav-menu"
        className={`${styles.drawer} ${menuOpen ? styles.drawerOpen : ""}`}
      >
        <ul className={styles.drawerList}>
          {NAV_ITEMS.map((item) => (
            <li key={item.href}>
              <a href={item.href} onClick={() => setMenuOpen(false)}>
                <span className={styles.drawerIndex}>{item.index}</span>
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className={styles.drawerFoot}>
          <a href={GITHUB_URL} target="_blank" rel="noreferrer">
            <Github size={15} />
            <span>GitHub</span>
          </a>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer">
            <Linkedin size={15} />
            <span>LinkedIn</span>
          </a>
          <a href={RESUME_URL} download="Pratik_Singh.pdf">
            <Download size={15} />
            <span>Resume (PDF)</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;